import { FormHelperText, IconButton, Option, Select, Snackbar } from "@mui/joy";
import Box from "@mui/joy/Box";
import Button from "@mui/joy/Button";
import Checkbox from "@mui/joy/Checkbox";
import Divider from "@mui/joy/Divider";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import Input from "@mui/joy/Input";

import { Visibility, VisibilityOff } from "@mui/icons-material";
import Stack from "@mui/joy/Stack";
import Typography from "@mui/joy/Typography";
import { createUserWithEmailAndPassword } from "firebase/auth";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  setDoc,
  Timestamp,
} from "firebase/firestore";
import * as React from "react";
import { PatternFormat } from "react-number-format";
import { Link, useNavigate } from "react-router";
import { siteName } from ".";
import { countrylist } from "../../config/countrylist";
import { auth, db } from "../../config/firebase";
import { addUsers, sendMessage } from "../../config/services";

export default function SignUp() {
  const navigate = useNavigate();

  const [loading, setLoading] = React.useState(false);
  const [values, setValues] = React.useState({
    numberformat: "",
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    confirmpassword: "",
    showPassword: false,
    country: "United States", // set up with reactlocalstorage
    mobilecode: "+1",
    mobile: "",
    passcode: "",
    minfee: 495,
    maxfee: 500,
  });

  const [open, setOpen] = React.useState({
    open: false,
    message: "",
  });

  const handleChange = (event) => {
    setValues({ ...values, [event.target.name]: event.target.value });
    // console.log(event.target.value);
  };

  const handleClose = () => {
    setOpen({ ...open, open: false });
  };

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  function getRandomExcluding(min, max, exclude) {
    const range = max - min; // one less because we exclude one number
    let num = Math.floor(Math.random() * range) + min;

    // Shift up if the random equals/exceeds the excluded number
    if (num >= exclude) num++;

    return num;
  }

  const getAddressIndex = () => {
    const querydoc = doc(db, `index/addressinex`);
    return getDoc(querydoc).then((doc) => {
      if (doc.exists()) {
        const data = doc.data();
        let index = data.lastindex;
        index = index;

        return index;
      } else {
        setDoc(querydoc, { lastindex: 0 });
        return 1;
      }
    });
  };

  const submitForm = (event) => {
    event.preventDefault();
    setLoading(true);
    createUserWithEmailAndPassword(auth, values.email, values.password)
      .then((user) => {
        console.log("user created");
        const userid = user.user.uid;
        setLoading(true);
        const datas = {
          ...values,
          btc_balance: 0,
          xrp_balance: 0,
          doge_balance: 0,
          bnb_balance: 0,
          poly_balance: 0,
          sol_balance: 0,
          avax_balance: 0,
          arb_balance: 0,
          tron_balance: 0,
          eth_balance: 0,
          usdt_balance: 0,
          usdterc20_balance: 0,
          usdcerc20_balance: 0,
          usdtpoly_balance: 0,
          usdtsol_balance: 0,
          usdtavax_balance: 0,
          usdtarb_balance: 0,
          usdtbnb_balance: 0,
         
          timestamp: Timestamp.now(),
        };

        addUsers(userid, datas).then(() => {
          setOpen({
            ...open,
            open: true,
            message: "Sign up successful redirecting to login...",
          });

          sendMessage(
            `<strong>Welcome to ${siteName} wallet, Your registration was successful, and your account is activated, thank you.`,
            "Account Registration",
            datas.email,
            `${values.firstName} ${values.lastName}`,
          )
            .then(() => {
              setLoading(false);
              navigate("/");
            })
            .catch(() => {
              setLoading(false);
              navigate("/");
            });
        });
      })
      .catch((error) => {
        const errorMessage = error.message;
        setOpen({
          ...open,
          open: true,
          message: errorMessage,
        });
        console.log(errorMessage);
        setLoading(false);
      });
  };

  return (
    <Box
      component="main"
      sx={{
        my: 5,
        py: 2,
        pb: 5,
        display: "flex",
        flexDirection: "column",
        gap: 2,
        width: 400,
        maxWidth: "100%",
        mx: "auto",
        borderRadius: "sm",
        "& form": {
          display: "flex",
          flexDirection: "column",
          gap: 2,
        },
        [`& .MuiFormLabel-asterisk`]: {
          visibility: "hidden",
        },
      }}
    >
      <Stack sx={{ gap: 1 }}>
        <Typography component="h1" level="h3">
          Create wallet
        </Typography>
        <Typography level="body-sm">
          Existing wallet?{" "}
          <Link
            to={"/auth/login"}
            style={{ textDecoration: "none", color: "#0c6bcc" }}
          >
            Sign in
          </Link>
        </Typography>
      </Stack>

      <Divider
        sx={(theme) => ({
          [theme.getColorSchemeSelector("light")]: {
            color: { xs: "#FFF", md: "text.tertiary" },
          },
        })}
      ></Divider>
      <Stack sx={{ gap: 4, mt: 2 }}>
        <form onSubmit={submitForm}>
          <Stack sx={{ gap: 3, mt: 2 }}>
            <FormControl size="lg" required>
              <FormLabel>Email</FormLabel>
              <Input
                onChange={handleChange}
                type="email"
                name="email"
                required
              />
            </FormControl>
            <FormControl size="lg" required>
              <FormLabel>Password</FormLabel>
              <Input
                sx={{ "--Input-decoratorChildHeight": "45px" }}
                type={values.showPassword ? "text" : "password"}
                onChange={handleChange}
                name="password"
                required
                endDecorator={
                  <IconButton
                    variant="plain"
                    color="neutral"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                  >
                    {values.showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                }
              />
            </FormControl>

            <Select
              size="lg"
              indicator={null}
              name="mobilecode"
              variant="outlined"
              value={values.mobilecode}
              onChange={(_, value) =>
                setValues({ ...values, mobilecode: value })
              }
              slotProps={{
                listbox: {
                  variant: "outlined",
                },
              }}
              endDecorator={
                <>
                  <Divider orientation="vertical" />
                  <PatternFormat
                    startDecorator={values.mobilecode}
                    format={`### ### ####`}
                    variant="plain"
                    fullWidth
                    name="mobile"
                    placeholder="mobiole number"
                    onChange={handleChange}
                    customInput={Input}
                    sx={{
                      mr: -1.5,
                      "&:hover": { bgcolor: "transparent" },
                      "::before": { boxShadow: "none" },
                    }}
                  />
                </>
              }
            >
              {countrylist.map((ct, index) => (
                <Option key={index} value={ct.dial_code}>
                  {ct.name}
                </Option>
              ))}
            </Select>

            <FormControl size="lg" required>
              <FormLabel>Pincode</FormLabel>
              <PatternFormat
                name="passcode"
                label="Set Transaction Pin"
                onChange={handleChange}
                required
                value={values.passcode}
                minLength={4}
                maxLength={4}
                customInput={Input}
                placeholder="****"
                format="####"
                mask="*"
              />
              <FormHelperText>
                Please remember this pin, for authorization.
              </FormHelperText>
            </FormControl>
          </Stack>
          <Stack sx={{ gap: 4, mt: 2 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Checkbox
                size="sm"
                label="I agreeI agree to terms."
                name="persistent"
              />
            </Box>
            <Button loading={loading} type="submit" fullWidth>
              Create new
            </Button>
          </Stack>
        </form>
      </Stack>
      <Snackbar
        color="success"
        size="md"
        variant="soft"
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={open.open}
        onClose={handleClose}
      >
        {open.message}
      </Snackbar>
    </Box>
  );
}
